/** Display-only partial JSON reader. Never used for executing tools. Preserves
 * string content before closing braces arrive, regardless of property order. */
export function partialJson(source: string): any {
  let i=0;
  const ws=()=>{while(/\s/.test(source[i] ?? '') && i<source.length)i++;};
  function str(): string {
    i++; let raw='';
    while(i<source.length) {
      const c=source[i++]; if(c==='"')break;
      if(c==='\\') { if(i>=source.length)break; const e=source[i++]; if(e==='u') { const digits=source.slice(i,i+4); if(!/^[\da-f]{4}$/i.test(digits))break; raw+='\\u'+digits;i+=4; } else raw+='\\'+e; }
      else raw+=c;
    }
    try{return JSON.parse('"'+raw+'"');}catch{return raw;}
  }
  function value(depth=0): any {
    if(depth>100)return undefined;
    ws();const c=source[i];
    if(c==='"')return str();
    if(c==='{' || c==='[') {
      i++;const object=c==='{'?Object.create(null):[];
      while(i<source.length) {
        ws();if(source[i]==='}' || source[i]===']'){i++;break;}
        const before=i;
        if(c==='{') { if(source[i]!=='"')break;const key=str();ws();if(source[i++]!==':')break;object[key]=value(depth+1); }
        else object.push(value(depth+1));
        ws();if(source[i]===',')i++;else if(source[i]!=='}' && source[i]!==']')break;
        if(i<=before)break;
      }
      return object;
    }
    const token=/^(?:true|false|null|-?\d+(?:\.\d+)?)/.exec(source.slice(i));
    if(token){i+=token[0].length;try{return JSON.parse(token[0]);}catch{}}
    return undefined;
  }
  return value();
}
